import { DynamicArrayGenerator } from '../../../utils/dynamic-array-generator';
import { DynamicComponentManifest } from '../../../dynamic-component-loader/dynamic-component-manifest';
import { Countries } from '../../../utils/countries-enum';

export class TaiwanManifest {
  da: DynamicArrayGenerator;
  constructor() {
    this.da = new DynamicArrayGenerator();
  }
  public getTWNManifest(): DynamicComponentManifest[] {
    const components = [
      {
        'key': 'tax-fee',
        'module': 'TaiwanModule'
      }, {
        'key': 'deal-file-check-list',
        'module': 'GlobalModule'
      }, {
        'key': 'company-names',
        'module': 'TaiwanModule'
      }, {
        'key': 'gaode-address-form',
        'module': 'TaiwanModule'
      }, {
        'key': 'gaode-map',
        'module': 'TaiwanModule'
      }, {
        'key': 'represented-party-address-gaode',
        'module': 'TaiwanModule'
      }, {
        'key': 'google-address-form',
        'module': 'GlobalModule'
      }, {
        'key': 'represented-party-address-google',
        'module': 'TaiwanModule'
      }, {
        'key': 'gst-fee-field',
        'module': 'GlobalModule'
      }, {
        'key': 'invoice-header',
        'module': 'GlobalModule'
      }, {
        'key': 'customer-approval-documents',
        'module': 'GlobalModule'
      }, {
        'key': 'gws-entity-location',
        'module': 'GlobalModule'
      }, {
        'key': 'gst-adjust',
        'module': 'TaiwanModule'
      }, {
        'key': 'billing-information',
        'module': 'GlobalModule'
      },
      {
        'key': 'tax-fee-percent',
        'module': 'GlobalModule'
      }
    ];
    return this.da.generateManifest(components, Countries.Taiwan);
  }
}
